export function TagList({ tags }: { readonly tags: readonly string[] }) {
  if (tags.length === 0) {
    return null;
  }

  return (
    <ul className="m-0 flex list-none flex-wrap gap-[7px] p-0">
      {tags.map((tag) => (
        <li
          key={tag}
          className="rounded-full border border-accent-line bg-accent-soft px-[11px] py-1 text-[11px] font-medium leading-normal text-accent"
        >
          {tag}
        </li>
      ))}
    </ul>
  );
}
